import { SHIPPING_COUNTRIES } from "./data/shipping-countries"
import { getCountryCodeByCountryName } from "./data/shipping-country-code"
import { CENTRA_LANGUAGE_CODE } from "./data/supported-languages"

export const euLocales = [
    `${CENTRA_LANGUAGE_CODE.En}`,
    `${CENTRA_LANGUAGE_CODE.De}`,
    `${CENTRA_LANGUAGE_CODE.Fr}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.CzechRepublic)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Denmark)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Norway)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Poland)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Sweden)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Switzerland)}`,
    `${CENTRA_LANGUAGE_CODE.De}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Switzerland)}`,
    `${CENTRA_LANGUAGE_CODE.Fr}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Switzerland)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.UnitedKingdom)}`
]
export const apacLocales = [
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Australia)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.NewZealand)}`
]
export const naLocales = [
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.USA)}`,
    `${CENTRA_LANGUAGE_CODE.Fr}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Canada)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Canada)}`
]
export const jpLocales = [
    `${CENTRA_LANGUAGE_CODE.Ja}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Japan)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Japan)}`
]

export const combinedLocales = [...euLocales, ...apacLocales, ...naLocales, ...jpLocales]

export type I18n = {
    readonly defaultLocale: string
    readonly locales: string[]
}

export const i18n = {
    defaultLocale: CENTRA_LANGUAGE_CODE.En,
    locales: combinedLocales
} as const

export const validateCentraLocale = (centraLocale: string) => {
    return i18n.locales.includes(centraLocale)
}

export type Locale = (typeof i18n)["locales"][number]
